import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import estadoMock from '../../../common/mock/estadoMock';
import global from '../../../common/utility/global';
import { OTROS, DNI, CARNET_EXTRANJERIA, PASAPORTE,RUC } from '../../../common/types/tipoDocumentoType';

import vendedorService from '../../../service/administracion/vendedorService';
import tipoDocumentoService from '../../../service/administracion/tipoDocumentoService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            estados: estadoMock.values,
            tiposDocumento: [],
            tipoVendedor: [],
            filter: {
                idTipodocumento: 0,
                numeroDocumento: '',
                nombresApellidos: '',
                estado: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idTipoDocumento: DNI.ID,
            numeroDocumento: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            correo:'',
            telefono: '',
            razonSocial: '',
            idTipoVendedor: 1,
            /******************/
            searchLoading: false,
            tiposDocumento: [],
            tipoVendedor: [],
        }
    };

    handleClearFilters = () => {
        var filter = {
            idTipodocumento: 0,
            numeroDocumento: '',
            nombresApellidos: '',
            estado: 0,
            ...FILTER
        };
 
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };

        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await vendedorService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Vendedor.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await vendedorService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Vendedor.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await vendedorService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await vendedorService.eliminar(values);
            else
                response = await vendedorService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.tiposDocumento = this.state.tiposDocumento;
        formValues.tipoVendedor= this.state.tipoVendedor;
        this.setState({ visible: true, formValues });
    };

    handleBuscarPadronReducido = async (idTipoDocumento, numeroDocumento, form) => {
        this.setState({ formValues: { ...this.state.formValues, searchLoading: true } });
        const response = await padronReducidoService.entidad({ idTipoDocumento, numeroDocumento });

        if (response.status === 200) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false
                }
            }, () => {
                form.setFieldsValue({
                    razonSocial: response.data.razonSocial,
                    direccion: response.data.direccion,
                    nombre: response.data.nombre,
                    apellidoMaterno: response.data.apellidoMaterno,
                    apellidoPaterno: response.data.apellidoPaterno
                });
            });
        }
        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            return;
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false
                }
            });
        }
        
    };

    handleEdit = async (values) => {
        const response = await vendedorService.obtenerPorId(values.id);
        if (response !== undefined) {
            response.tiposDocumento = this.state.tiposDocumento;
            response.tipoVendedor= this.state.tipoVendedor;
            this.setState({ visible: true, formValues: response });
        }
    };

    handleChangeForm = async (property, value) => {
        if (property === "clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provincias: [],
                    distritos: []
                }
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            
            if (values.id === 0)
                response = await vendedorService.registrar(values);
            else
                response = await vendedorService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };
    async componentDidMount() {
        this._initPagination(this.state.filter, vendedorService.paginacion);

        const tiposDocumento = await tipoDocumentoService.listar();
        const tipoVendedor = [{'id':1,'nombre':'Vendedor Interno'},{'id':2,'nombre':'Agente de Ventas'}]

        this.setState({
            loadingSource: false,
            tiposDocumento: tiposDocumento ? tiposDocumento.filter(m => [OTROS.ID, DNI.ID, CARNET_EXTRANJERIA.ID, PASAPORTE.ID,RUC.ID].includes(m.id)) : [],
            tipoVendedor:tipoVendedor? tipoVendedor : [],
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Vendedor"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    tiposDocumento={this.state.tiposDocumento}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onChange={this.handleChangeForm}
                    onBuscarPadronReducido={this.handleBuscarPadronReducido}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        )
    }
}